import { useParams } from "react-router-dom";

import { computed } from "mobx";
import { inject, observer } from "mobx-react";

import CompaniesCreate from "./Create";
import CompaniesEdit from "./Edit";

const CompaniesDetail = inject("mainStore")(
    observer(({ mainStore }) => {
        const companies = computed(() => mainStore.getMainStore("companies")).get();
        const { secondParam } = useParams();
        const Specified = secondParam === "add" || companies?.isDraft ? CompaniesCreate : CompaniesEdit;

        return <Specified />;
    }),
);

export default CompaniesDetail;
